@breakpoint-xs: 480px; // Extra-small breakpoint — large phones and up.
@breakpoint-sm: 768px; // Small breakpoint — tablets portrait and up.
@breakpoint-md: 992px; // Medium breakpoint — tablets landscape / small laptops and up.
@breakpoint-lg: 1200px; // Large breakpoint — desktops and up.
@breakpoint-xl: 1600px; // Extra-large breakpoint — wide desktops and up.
